import * as common from 'store/modules/common'

export const prefix = 'notifications'

const initialState = {
  notifications: []
}
export const actionTypes = {
  notification: `${prefix}/notification`,
  updateBackgroundAction: `${prefix}/updateBackgroundAction`,
  refreshNeeded: `${prefix}/refreshNeeded`
}

export const actionCreators = {
  notify: (payload) => ({
    type: actionTypes.notification,
    payload
  }),
  updateBackgroundAction: (payload) => ({
    type: actionTypes.updateBackgroundAction,
    payload
  }),
  refreshNeeded: (payload) => ({
    type: actionTypes.refreshNeeded,
    payload
  })
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.notification: return { ...state, notifications: [...state.notifications, { payload: action.payload } ]}
    default: return common.reducer(state, action, prefix)
  }
}
